
import React, { useState } from "react";
import { FaShoppingCart } from "react-icons/fa"; // Shopping cart icon
import riceImg from "./SOUTH.jpeg";
import Modal from "react-modal";  // ✅ Import Modal
import { useNavigate } from "react-router-dom";
import axios from "axios";  // axios ko import karna zaroori hai
import  Cateringresturentcard from './Cateringresturentcard';
Modal.setAppElement("#root"); // required for accessibility


// Packages with categories
const packagesData = {
  birthday: [
    {
  id: 1,
  
  type: "veg",
  image: riceImg,
  items: [
    { id: 1, name: "Rice", price: 100, type: "veg" },
    { id: 2, name: "Paneer Masala", price: 180, type: "veg" },
    { id: 3, name: "Dal Tadka", price: 120, type: "veg" },
    { id: 4, name: "Aloo Gobi", price: 90, type: "veg" },
    { id: 5, name: "Chole", price: 110, type: "veg" },
    { id: 6, name: "Mix Veg Curry", price: 140, type: "veg" },
    { id: 7, name: "Pulao", price: 130, type: "veg" },
    { id: 8, name: "Poori Bhaji", price: 100, type: "veg" },
    { id: 9, name: "Sweets", price: 80, type: "veg" },
    { id: 10, name: "Paneer Butter Masala", price: 200, type: "veg" },
  ],
},
    {
      id: 2,
     
      type: "nonveg",
      image: riceImg,
      items: [
        { id: 1, name: "Chicken Curry", price: 250 },
        { id: 2, name: "Fish Fry", price: 300 },
        { id: 3, name: "Mutton Curry", price: 350 },
        { id: 4, name: "Egg Curry", price: 120 },
        { id: 5, name: "Prawns Masala", price: 400 },
        { id: 6, name: "Chicken Biryani", price: 280 },
        { id: 7, name: "Mutton Biryani", price: 350 },
        { id: 8, name: "Tandoori Chicken", price: 320 },
        { id: 9, name: "Chicken Kebab", price: 200 },
        { id: 10, name: "Fish Curry", price: 270 },
      ],
    },
    {
      id: 3,
      
      type: "drinks",
      image: riceImg,
      items: [
        { id: 1, name: "Cold Drink", price: 40 },
        { id: 2, name: "Juice", price: 100 },
        { id: 3, name: "Mocktail", price: 150 },
        { id: 4, name: "Shakes", price: 120 },
        { id: 5, name: "Mineral Water", price: 20 },
        { id: 6, name: "Soda", price: 30 },
        { id: 7, name: "Coffee", price: 60 },
        { id: 8, name: "Tea", price: 30 },
        { id: 9, name: "Green Tea", price: 50 },
        { id: 10, name: "Energy Drink", price: 80 },
      ],
    },
  ],

};


export default function FoodMenu({ onNext }) {
  const [filter, setFilter] = useState("all"); // veg / nonveg filter
  const [selectedPage, setSelectedPage] = useState("birthday"); // package filter
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [step, setStep] = useState(1); // step 1 = form, step 2 = summary



  const userId = localStorage.getItem("userId");
  const [showLogin, setShowLogin] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [hovered, setHovered] = useState(null);
    const navigate = useNavigate();
  const [formData, setFormData] = useState({
    event: "",
    date: "",
    time: "",
    people: "",
    location: "",
    phone: "",
    email: "",
    foodType: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const openModal = () => {
    setStep(1);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleNext = () => {
    setStep(2);
  };

  const handleConfirm = () => {
    const booking = {
      event: formData.event,
      eventDate: formData.date,
      eventTime: formData.time,
      numberOfPeople: formData.people,
      location: formData.location,
      contact: {
        phone: formData.phone,
        email: formData.email,
      },
      foodPreference: formData.foodType,
      bookingTimestamp: new Date().toISOString(),
    };

  }

  const isMobile = window.innerWidth <= 768;

  // filter categories based on package + veg/nonveg filter
  const mergedData = [
 ...(packagesData["birthday"] || []),
    ...(packagesData["wedding"] || []),
    ...(packagesData["corporate"] || []),
  ];

  const selectedData =
    selectedPage === "all" ? mergedData : packagesData[selectedPage] || [];

  const filteredCategories =
    filter === "all"
      ? selectedData
      : selectedData.filter((c) => c.type === filter);


  const handleAddToCart = (category) => {
    setSelectedCategory(category);
    setIsModalOpen(true);
  };

  const handlePageChange = (e) => {
    setSelectedPage(e.target.value);
  };
  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };


  const handleProceed = () => {
    if (typeof onNext === "function") {
      onNext();
    } else {
      console.error("onNext prop is not a function!");
    }
  };

  // const handleViewCart = () => {
  //   setIsModalOpen(false); // Modal close karna ho to
  //   navigate("/Catreingpakagecartpage");     // Cart page par redirect
  // };

  const goToCart = () => {
    setIsModalOpen(false);
    navigate("/Catreingpakagecartpage");
  };

  const addToCart = async (item, quantity = 1) => {
    console.log("addToCart called with dishId:", item.dishId);

    if (!userId) {
      setShowLogin(true);
      return;
    }

    const orderType = "DINE_IN";
    const apiUrl = ` https://backend.maamaas.com/food/api/cart/add/${userId}?orderType=${orderType}`;

    const data = {
      dishId: item.dishId,
      quantity: quantity,
    };

    try {
      const response = await axios.post(apiUrl, data, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200) {
        console.log("Item successfully added to cart:", response.data);

        setCartItems((prevItems) => {
          const existingItem = prevItems.find(
            (cartItem) => cartItem.dishId === item.dishId
          );
          if (existingItem) {
            return prevItems.map((cartItem) =>
              cartItem.dishId === item.dishId
                ? { ...cartItem, quantity }
                : cartItem
            );
          } else {
            return [...prevItems, { ...item, quantity }];
          }
        });

        setQuantities((prev) => ({
          ...prev,
          [item.dishId]: quantity,
        }));

        setQuantity(quantity);
        setIsModalOpen(true);
        setTimeout(() => {
          if (!hovered) {
            setIsModalOpen(false);
          }
        }, 2000);
      } else {
        console.error("Failed to add item to cart:", response.data);
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
      if (error.response) {
        if (error.response.status === 500) {
          alert("✅Please select your orderType here....");
        } else if (error.response.status === 404) {
          alert("Item not found. Please try again.");
        } else {
          alert(`Error: ${error.response.data}`);
        }
      } else {
        alert("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <div className="menu-container">
      <style>{`
        .menu-container {
          padding: 20px;
          font-family: Arial, sans-serif;
          margin-top: -24px;
        }
        .filter-buttons {
          text-align: center;
          margin-bottom: 20px;
          margin-top:0px;
        }
        .filter-buttons button {
          margin: 0 10px;
          padding: 10px 20px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          background: #eee;
          font-weight: bold;
        }
        .filter-buttons .active {
          background: green;
          color: white;
        }
        .card-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          
          gap: 20px;
        }
        @media (max-width: 900px) {
          .card-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 600px) {
          .card-grid {
            grid-template-columns: 1fr;
          }
        }
        .category-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  min-height: 320px; /* pehle fixed tha, ab minimum rakha */
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* neeche se hata ke upar se shuru */
  color: white;
  font-weight: bold;
  // box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  background-size: cover;
  background-position: center;
  padding-bottom: 15px; /* neeche jagah mile */
}

.item-list {
  margin-bottom: 10px;
  /* yeh dono hata do */
  max-height: none; 
  overflow-y: visible;
}
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
        }
        .category-content {
          position: relative;
          padding: 15px;
        }
        .category-title {
          font-size: 20px;
          margin-bottom: 10px;
        }
       
        .item-row {
          display: flex;
          justify-content: space-between;
          padding: 4px 0;
          border-bottom: 1px solid rgba(255,255,255,0.2);
          font-size: 14px;
        }
        .item-row:last-child {
          border-bottom: none;
        }
        .add-btn {
          padding: 8px 16px;
          background: orange;
          border: none;
          border-radius: 6px;
          color: white;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
        }
        .book-btn {
          margin-top: 15px;
          padding: 10px;
          border: none;
          background: blue;
          color: white;
          border-radius: 6px;
          cursor: pointer;
          font-weight: bold;
        }
      `}</style>
<div style={{textAlign:"center",fontSize:'30px',fontWeight:'bold',color:'black',textDecoration:"none"}}>
  <h1>Our Package</h1>
</div>
        <div className="card-grid" style={{ marginLeft: isMobile ? 0 : "0px",marginTop:"0px" }}>
          {filteredCategories.map((category) => (
            <div
              key={category.id}
              className="category-card"
              style={{ backgroundImage: `url(${category.image})` }}
            >
              <div className="overlay"></div>
              <div className="category-content">
                <div className="category-title">{category.name}</div>
                <div className="item-list">
                  {category.items.map((item) => (
                    <div key={item.id} className="item-row">
                      <span>{item.name}</span>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "12px",
                    paddingTop: "8px",
                    borderTop: "2px solid #fff",
                  }}
                >
                  <button
                    className="add-btn"
                    style={{ padding: "6px 14px", marginRight: "12px" }}
                    onClick={() => handleAddToCart(category)}
                  >
                    Add to Cart
                  </button>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginLeft: "12px",
                    }}
                  >
                    ₹{category.items.reduce(
                      (total, item) => total + item.price,
                      0
                    )}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
  {/* <button
    type="button"
    onClick={handleProceed}
    style={{
      backgroundColor: "#b169ccff",
      color: "white",
      padding: "10px 20px",
      fontSize: "16px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      cursor: "pointer",
      transition: "0.3s",
    }}
    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#c566f4ff")}
   
  >
    ✅ If you’re not interested, Skip
  </button> */}
  
</div>

      {/* </div> */}

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Add to Cart"
        style={{
          overlay: { backgroundColor: "transparent" },
          content: {
            position: "absolute",
            top: "92%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "600px",
            border: "none",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            padding: "0px",
            height: "100px",
            borderRadius: "10px",
          },
        }}
      >
        {selectedCategory && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 20px",
              width: "100%",
              fontWeight: "bold",
              color: "#333",
              borderRadius: "10px",
              height: "80px",
              gap: "15px",
            }}
          >
            <FaShoppingCart style={{ fontSize: "28px", color: "#ee6521" }} />
            <div style={{ fontSize: "18px", whiteSpace: "nowrap" }}>
              {selectedCategory.name}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                onClick={() =>
                  setSelectedCategory((prev) => ({
                    ...prev,
                    qty: Math.max((prev.qty || 1) - 1, 1),
                  }))
                }
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  border: "none",
                  background: "#eee",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                -
              </button>
              <span style={{ fontSize: "16px" }}>
                {selectedCategory.qty || 1}
              </span>
              <button
                onClick={() =>
                  setSelectedCategory((prev) => ({
                    ...prev,
                    qty: (prev.qty || 1) + 1,
                  }))
                }
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                +
              </button>
            </div>
            <button
                        style={{
                          borderRadius: "50px",
                          background: "#ee6521",
                          color: "#fff",
                          padding: "8px 16px",
                          border: "none",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                        }}
                        onClick={goToCart}
                      >
                        View Cart
                      </button>
          </div>
        )}
      </Modal>
      <div>
    
    </div>
    {/* <Cateringresturentcard/> */}
    </div>
    
  );
}


